import { ErrorHandlerProvider } from './handlers/error.handler';

export { ErrorHandlerProvider } from './handlers/error.handler';

export const HANDLERS: any[] = [
	ErrorHandlerProvider
];
